import styles from './style.module.scss';
import { Images, Svgs } from '../../assets';
import { constant } from '../../utils';
import moment from 'moment';

export default function Component() {
  return (
    <section className={styles.container}>
      <div className={styles.iconContainer}>
        <div
          className={styles.icon}
          onClick={() => window.open(constant.instaUrl, '_black')}
        >
          <img src={Images.Instagram} alt="instagram" />
        </div>
        <div
          className={styles.icon}
          onClick={() => window.open(constant.kakaoUrl, '_black')}
        >
          <Svgs.KakaoTalk />
        </div>
      </div>
      <div className={styles.textContainer}>
        <span>88, World Cup buk-ro, Mapo-gu, Seoul, Republic of Korea</span>
        <br />
        <a href={`mailto:${constant.email}`}>{constant.email}</a>
        <br />
        <span>
          Copyright ⓒ {moment().format('YYYY')} OHU &nbsp;All rights reserved.
        </span>
      </div>
    </section>
  );
}
